import {PearlHarborGameMode} from "../../server/PearlHarborGameMode";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {gsap, TimelineLite, TweenLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {PearlHarborSoundManager} from "../../sound/PearlHarborSoundManager";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {BasicBitmapCountUp} from "../../components/BasicBitmapCountUp";
import {PearlHarborGameAssets} from "../../PearlHarborGameAssets";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborSoundConfig} from "../../sound/PearlHarborSoundConfig";

export class PearlHarborFSOutro extends PIXI.Container implements StageLayer {

    private _overlay:PIXI.Graphics;
    private _outroSpine:PIXI.spine.Spine | null;
    private _outroSpineContainer:PIXI.Sprite;
    private _button:ContinueButton;
    private _clickCallback:Function;
    private _totalWinText:PIXI.Text;
    private _countUp:BasicBitmapCountUp;
    static TOTAL_WIN_TEXT_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Arial",
        fontWeight : "bold",
        fill : ["#ffffff"],
        fontSize : "64px",
        stroke : 0x000000,
        strokeThickness : 8,
        wordWrap : true,
        wordWrapWidth : 800,
        dropShadow : true,
        dropShadowAngle : 8,
        dropShadowBlur : 4,
        dropShadowDistance : 4
    });
    static TOTAL_WIN_AMOUNT_TEXT_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Arial",
        fontWeight : "bold",
        fill : ["#000000"],
        fontSize : "96px",
        stroke : 0xffffff,
        strokeThickness : 8,
        wordWrap : true,
        wordWrapWidth : 800,
        dropShadow : true,
        dropShadowAngle : 8,
        dropShadowBlur : 4,
        dropShadowDistance : 4
    });

    constructor() {
        super();
        this.name = "FS_OUTRO";
        this.init();
    }

    private init():void {
        this._overlay = new PIXI.Graphics();
        this._overlay.position.set(360, 360);
        this._overlay.beginFill(0x000000);
        this._overlay.drawRect(-840, -840, 1680, 1680);
        this._overlay.endFill();
        this._overlay.alpha = 0;
        this.addChild(this._overlay);

        this._outroSpineContainer = new PIXI.Sprite();
        this.addChild(this._outroSpineContainer);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.position.set(360, 530);
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;
        this.addChild(this._button);
        this._totalWinText = this.createText("TOTAL WIN", PearlHarborFSOutro.TOTAL_WIN_TEXT_STYLE);
        this._totalWinText.position.y = 177;
        this._countUp = new BasicBitmapCountUp({
            fontName : PearlHarborGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 290,
            tint : 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 360);
        this._countUp.scale.set(0.7, 0.7);
        this._countUp.stopAt(0);
        this._countUp.alpha = 0;
        this.addChild(this._countUp);
        this.visible = false;
    }

    public precalculateScale(endValue:number):void {
        this._countUp.stopAt(0);
        this._countUp.preCalculateScale(0, endValue);
    }

    private createText(textStr:string, style:PIXI.TextStyle):PIXI.Text {
        const screenBounds:ScreenBounds = NolimitApplication.screenBounds;
        const text:PIXI.Text = new PIXI.Text(PearlHarbor.apiPlugin.translations.translate(textStr), style);
        text.anchor.set(0.5, 0.5);
        text.position.x = screenBounds.center;
        text.alpha = 0;
        this.addChild(text);
        return text;
    }

    private onButtonClick(playClickSound:boolean):void {
        if(playClickSound) {
            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.CONTINUE_BUTTON);
        }
        PearlHarborSoundManager.onFsOutroContinue();
        PearlHarbor.kamakazi.hide()
        PearlHarbor.model.buyFeatureName = ""; //resetBuyFeatureName
        const hideFSOutroTL:TimelineLite = new TimelineLite(),
            fadeOutDuration:number = 0.4;
        hideFSOutroTL.add([() => {
            PearlHarbor.setMode(PearlHarborGameMode.NORMAL);
            this._button.enable(false);
            this._button.alpha = 0;
            PearlHarbor.enteringInFs = false;
            PearlHarbor.mainGameZoomContainer.showOnFSOutro();
            PearlHarbor.activeSymbolsBackground.showOnFSOutro();
            PearlHarbor.keypadPlugin.setZeroBetSpinCounter(-1);
            PearlHarbor.cocpitBoard.reset();
        },
            gsap.to([this._totalWinText, this._countUp, this._outroSpine, this._overlay], {
                duration : fadeOutDuration,
                alpha : 0
            })
        ]);
        hideFSOutroTL.add(() => {
            this._outroSpineContainer.removeChildren();
            this._clickCallback();
            this._outroSpine = null;
            this.visible = false;
        });
        hideFSOutroTL.add(PearlHarbor.keypadPlugin.show());
    }

    public show(callback:Function):TimelineLite {
        const isWinBelowStake = PearlHarborHelper.isWinBelowStake();
        const showFSOutroTL:TimelineLite = new TimelineLite();
        this._clickCallback = callback;
        PearlHarbor.keypadPlugin.hide();
        PearlHarbor.keypadPlugin.setWin(PearlHarbor.model.gameData.accumulatedRoundWin, true, isWinBelowStake);

        if(PearlHarbor.model.gameData.brokeBank) {
            this.onButtonClick(false);
            return showFSOutroTL;
        }
        showFSOutroTL.add(() => {
            this.visible = true;
            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.FS_OUTRO_FADE_IN);
        });
        showFSOutroTL.add(gsap.fromTo(this._overlay, {alpha : 0}, {alpha : 1, duration : 1}));
        showFSOutroTL.add(() => {PearlHarborSoundManager.playFSEndSound();});

        let betLevel = PearlHarbor.apiPlugin.freeBets.hasFreeBets() ? PearlHarbor.apiPlugin.freeBets.getBet() : PearlHarbor.apiPlugin.betLevel.getLevel();
        let featureBuyPrice:number = PearlHarbor.model.gameData?.playedBetValue || parseFloat(betLevel);
        const buyType:number = PearlHarbor.model.gameData.mode === GameMode.FREESPIN ? 0 : 1;
        featureBuyPrice *= PearlHarbor.model.initData.featureBuyTimesBetValue[buyType].price;
        const startTime:number = showFSOutroTL.duration(),
            isDisappointed:boolean = PearlHarbor.model.gameData.accumulatedRoundWin < (featureBuyPrice * 0.26);

            if(this._outroSpine) {
                this._outroSpine = null;
            }
            this._outroSpine = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset("FSOutro"));
            this._outroSpine.position.set(360, 360);

        this._totalWinText.visible = !isWinBelowStake;
            showFSOutroTL.add([
                TweenLite.to(this._totalWinText, 0.2, {alpha : 1}),
                () => {
                    this._outroSpineContainer.addChild(this._outroSpine!);
                    this._outroSpine!.visible = true;
                    this._outroSpine!.alpha = 1;
                    this._outroSpine!.state.setAnimation(0, "idle", true);
                }
            ], startTime);
            Logger.logDev(`outro ----> type: ${buyType}, price: ${featureBuyPrice}, win: ${PearlHarbor.model.gameData.accumulatedRoundWin}`);
            if(isDisappointed || isWinBelowStake) {
                showFSOutroTL.add([
                    () => {PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.FS_OUTRO_MEDAL[0]);},
                    new SpineTween(this._outroSpine, 1, "disappointed")
                ]);
            } else {
                showFSOutroTL.add([
                    () => {
                        this._outroSpine?.state.setAnimation(6, "sakuraLeaves1", true);
                        PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.FS_OUTRO_MEDAL[1]);
                    },
                    new SpineTween(this._outroSpine, 1, "lev1")
                ]);
            }

            if(!isWinBelowStake) {
                if (PearlHarbor.model.gameData.accumulatedRoundWin >= (featureBuyPrice * 0.5)) {
                    showFSOutroTL.add([
                        () => {
                            this._outroSpine?.state.setAnimation(7, "sakuraLeaves2", true);
                            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.FS_OUTRO_MEDAL[2]);
                        },
                        new SpineTween(this._outroSpine, 2, "lev2")
                    ]);
                }
                if (PearlHarbor.model.gameData.accumulatedRoundWin >= (featureBuyPrice * 1.1)) {
                    showFSOutroTL.add([
                        () => {
                            this._outroSpine?.state.setAnimation(8, "sakuraLeaves3", true);
                            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.FS_OUTRO_MEDAL[3]);
                        },
                        new SpineTween(this._outroSpine, 3, "lev3")
                    ]);
                }
                if (PearlHarbor.model.gameData.accumulatedRoundWin >= (featureBuyPrice * 2)) {
                    showFSOutroTL.add([
                        () => {
                            this._outroSpine?.state.setAnimation(9, "rotatingFlag", true);
                            PearlHarborSoundManager.playSoundEffect(PearlHarborSoundConfig.FS_OUTRO_MEDAL[4]);
                        },
                        new SpineTween(this._outroSpine, 4, "lev4")
                    ]);
                }
                if (PearlHarbor.model.gameData.accumulatedRoundWin >= (featureBuyPrice * 6)) {
                    showFSOutroTL.add([
                        () => {
                            this._outroSpine?.state.setAnimation(10, "lev5", true)
                        },
                        new SpineTween(this._outroSpine, 5, "lev5")
                    ]);
                }
            }

        showFSOutroTL.add([
            () => {
                if(!(isDisappointed || isWinBelowStake)) {
                    PearlHarborSoundManager.playCountUpStart();
                }
                this._countUp.alpha = 1;
            },
            this._countUp.getCountAnimation((isDisappointed || isWinBelowStake) ? PearlHarbor.model.gameData.accumulatedRoundWin : 0, PearlHarbor.model.gameData.accumulatedRoundWin, (isDisappointed || isWinBelowStake) ? 0 : 3)
        ], startTime + 0.2);
        showFSOutroTL.add(() => {
            if(!(isDisappointed || isWinBelowStake)) {
                PearlHarborSoundManager.playFSOutroCountUpEnds()
            }
        });
        showFSOutroTL.add(
            TweenLite.to(this._button, 0.2, {
                alpha : 1, onComplete : () => {
                    this._button.enable(true);
                }
            }));
        return showFSOutroTL;
    }
}